<template>
  <touch-layout>
    <template #header_page_breadcrumb>
      <Breadcrumbs
        :routes="[
          ['Dashboard', '/'],
          ['Setup', '/setup'],
          ['Panel'],
        ]"
      />
    </template>
    <template #header_page_title> Labour </template>
    <Menu />
    <div class="flex flex-col grow">
      <div class="flex flex-col md:flex-row gap-5 p-5 grow bg-gray-200 w-full overflow-y-auto md:overflow-y-auto" style="flex: 1 1 0">
        <div class="flex flex-col gap-5">
          <div class="bg-white p-5 border border-gray shrink-0" style="min-width: 250px">
            <div
              class="flex items-center gap-3 p-2 rounded bg-gray-200 cursor-pointer"
              :class="{ 'bg-green-600 text-white': !$route.query.productId }"
              @click="$router.push({ query: { productId: undefined, isCopyFrom: undefined } })"
            >
              <span>Rates</span>
              <i class="ml-auto fal fa-cog" />
            </div>
          </div>
          <div class="flex flex-col gap-2 bg-white p-5 border border-gray grow" style="min-width: 250px">
            <loading v-if="isLoadingProducts" :loading="true" class="h-full" style="min-height: 200px; flex: 1 1 0" />
            <div
              v-else-if="products.length > 0"
              class="overflow-y-auto" 
              style="min-height: 200px; min-width: 200px; flex: 1 1 0"
            >
              <div
                v-for="_product in products"
                :key="_product.id"
                class="mb-2 p-2 rounded bg-gray-200 cursor-pointer"
                :class="{ 'bg-green-600 text-white': _product.id == $route.query.productId }"
                @click="$router.push({ query: { productId: _product.id, isCopyFrom: undefined } })"
              >
                {{ _product.description }}
              </div>
            </div>
            <div v-else class="overflow-hidden flex flex-col grow justify-around text-center px-5"> No Products Found</div>
          </div>
        </div>
        <div class="flex flex-col gap-2 bg-white px-5 w-full border border-gray" style="flex: 1 1 0">
          <div v-if="product" class="md:overflow-y-auto pt-5" style="flex: 1 1 0">
            <div class="bg-white grid grid-cols-2 gap-5 p-5 max-w-6xl">
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Corner Joint Square</b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cornerJointSquareWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cornerJointSquareMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Corner Joint Angled</b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cornerJointAngledWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cornerJointAngledMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>T Joint Square</b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.tJointSquareWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.tJointSquareMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>T Joint Angled</b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.tJointSquareWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.tJointAngledMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Butt Joint </b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.buttJointWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.buttJointMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Cruciform Joint  </b>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Weld</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cruciformJointWeld"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Mech</span>
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.cruciformJointMech"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / joint</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Opener</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.opener"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / opener</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Fixed</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.fixed"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / fixed sash/slab</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Beading</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.beading"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / aperture</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Glazing</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.glazing"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / aperture</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Ancillary</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.ancillary"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / piece</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="bg-gray-200 text-center rounded p-3">
                  <b>Reinforcing</b>
                </div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center bg-white rounded border overflow-hidden">
                    <input
                      v-model.number="product.reinforcing"
                      type="number"
                      class="grow p-2 w-24"
                      min="0"
                    >
                    <div class="border-l px-2 opacity-75">
                      <span>units / piece</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="grid grid-cols-2 gap-5 p-5 max-w-6xl">
            <div class="flex flex-col gap-1">
              <div>
                Cost (per unit)
              </div>
              <div class="flex items-center bg-white rounded border overflow-hidden w-full">
                <div class="border-r px-2">
                  <span>£</span>
                </div>
                <input
                  v-model.number="cost"
                  type="number"
                  class="grow p-2 w-24"
                  min="0"
                >
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <div>
                Price (per unit)
              </div>
              <div class="flex items-center bg-white rounded border overflow-hidden w-full">
                <div class="border-r px-2">
                  <span>£</span>
                </div>
                <input
                  v-model.number="price"
                  type="number"
                  class="grow p-2 w-24"
                  min="0"
                >
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <div>
                Financial Category
              </div>
              <div>
                <select v-model="financialCategory" class="border w-full rounded p-2 bg-white">
                  <option :value="0">None</option>
                  <option :value="1">Trade</option>
                  <option :value="2">Retail</option>
                  <option :value="3">Commercial</option>
                  <option :value="4">New Build</option>
                </select>
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <div>
                Discount Category
              </div>
              <div>
                <select v-model="financialCategory" class="border w-full rounded p-2 bg-white">
                  <option :value="0">None</option>
                  <option :value="1">Trade</option>
                  <option :value="2">Retail</option>
                  <option :value="3">Commercial</option>
                  <option :value="4">New Build</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sticky bottom-0 bg-white text-right p-3 border-t flex">
        <div class="ml-auto flex gap-2">
          <button
            v-if="product && !$route.query.isCopyFrom"
            class="flex items-center gap-2 btn btn-primary btn-lg"
            :class="{
              'opacity-25 pointer-events-none ':
                JSON.stringify(product) !== JSON.stringify(originalProduct),
            }"
            @click="promptToSave(() => isCopyTo = true)"
          >
            <span>Copy to</span>
            <i v-if="!copy_url_button_clicked" class="fal fa-copy ml-3" />
          </button>
          <div v-else-if="$route.query.isCopyFrom" class="px-5 py-3">
            <span class="px-3 py-2 rounded">
              Copied from <b>{{
                products.find(x => x.id == $route.query.isCopyFrom).description
              }}</b>
            </span>
          </div>
          <button
            class="btn btn-action btn-lg"
            :class="{
              'opacity-50 pointer-events-none bg-gray-500 border-gray-500':
                JSON.stringify(product) === JSON.stringify(originalProduct),
            }"
            @click="save()"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
    <Teleport defer to="#portal_popup"> 
      <modal-window v-if="isCopyTo" :modal_open="isCopyTo" :title="`Copy ${product.description} to...`" @close="isCopyTo = false">
        <div
          v-for="_product in products.filter(x => x.id !== product.id)"
          :key="_product.id"
          class="mb-2 p-2 rounded bg-gray-200 cursor-pointer"
          @click="$router.push({ query: { productId: _product.id, isCopyFrom: product.id } })"
        >
          {{ _product.description }}
        </div>
      </modal-window>
    </Teleport>
  </touch-layout>
</template>

<script>

import Menu from '@/components/business/productSetup/Menu.vue';
import Breadcrumbs from '@/components/shared/Breadcrumbs.vue';

export default {
  components: {
    Menu,
    Breadcrumbs
  },
  beforeRouteUpdate(to, from, next) {
    this.promptToSave(() => next())
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'Error') {
      next()
    } else {
      this.promptToSave(() => next())
    }
  },
  data() {
    return {
      productId: undefined,
      product: undefined,
      originalProduct: undefined,
      isCopyTo: false,
      products: [
        {
          description: 'Product A',
          id: 1,
          cornerJointSquareWeld: 4,
          cornerJointSquareMech: 3,
          cornerJointAngledWeld: 1,
          cornerJointAngledMech: 7,
          tJointSquareWeld: 15,
          tJointSquareMech: 1,
          tJointAngledWeld: 4,
          tJointAngledMech: 40,
          buttJointWeld: 27,
          buttJointMech: 2,
          cruciformJointWeld: 10,
          cruciformJointMech: 10,
          opener: 130,
          fixed: 41,
          beading: 4,
          glazing: 6,
          ancillary: 12,
          reinforcing: 2
        },
        {
          description: 'Product B',
          id: 2,
          cornerJointSquareWeld: 10,
          cornerJointSquareMech: 10,
          cornerJointAngledWeld: 10,
          cornerJointAngledMech: 10,
          tJointSquareWeld: 10,
          tJointSquareMech: 10,
          tJointAngledWeld: 10,
          tJointAngledMech: 10,
          buttJointWeld: 10,
          buttJointMech: 10,
          cruciformJointWeld: 10,
          cruciformJointMech: 10,
          opener: 10,
          fixed: 10,
          beading: 10,
          glazing: 10,
          ancillary: 10,
          reinforcing: 10
        }
      ],
      loading: true,
      isLoadingProducts: false,
    };
  },
  watch: {
    '$route.query': {
      async handler({ productId, isCopyFrom }) {
        if (productId) {
          const product = this.products.find(x => x.id == productId)
          if (isCopyFrom) {
            this.product = { ...this.product, id: product.id, description: product.description }
            this.originalProduct = JSON.parse(JSON.stringify(product))
            this.isCopyTo = false
          } else {
            this.product = product
            this.originalProduct = JSON.parse(JSON.stringify(this.product))
          }
        } else {
          this.product = undefined
          this.originalProduct = undefined
        }
      },
      immediate: true,
    },
  },
  methods: {
    promptToSave(callback) {
      if (JSON.stringify(this.product) !== JSON.stringify(this.originalProduct)) {
        this.alertBox()
          .fire({
            title: 'There are unsaved changes',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Go Back',
            confirmButtonText: 'Continue',
          })
          .then((result) => {
            if (result.value) {
              callback()
            }
          })
      } else {
        callback()
      }
    }
  }
};
</script>